module.exports = __webpack_public_path__ + "media/thumbnails/shoe-style-2-de709965.svg";